import {
	Checkbox,
	DatePicker,
	Flex,
	Form,
	Input,
	InputNumber,
	Radio,
	Select,
} from "antd";

export default function QuestionSubOption({
	data,
	subData,
	subAnswer,
	handleChange,
	isOthers,
}) {
	switch (subData.sub_option_type) {
		case "Text (Input)":
			return (
				<Form.Item name={`q_${data.id}_sub`}>
					<Input
						placeholder="Input answer"
						onBlur={(e) => handleChange(e.target.value, `q_${data.id}_sub`, 1)}
					/>
				</Form.Item>
			);
		case "Number (Input)":
			return (
				<Form.Item name={`q_${data.id}_sub`}>
					<InputNumber
						placeholder="Input answer"
						onBlur={(e) => handleChange(e.target.value, `q_${data.id}_sub`, 1)}
					/>
				</Form.Item>
			);
		case "Radio (Button)":
			return (
				<>
					<Form.Item name={`q_${data.id}_sub`}>
						<Radio.Group
							size="large"
							onChange={(e) =>
								handleChange(e.target.value, `q_${data.id}_sub`, 1)
							}
						>
							<Flex vertical="vertical">
								{subData.sub_options
									? subData.sub_options.map((item, index) => {
											return (
												<Radio key={index} value={item.option}>
													{item.option}
												</Radio>
											);
									  })
									: ""}
							</Flex>
						</Radio.Group>
					</Form.Item>

					{isOthers ? (
						<Form.Item name={`q_${data.id}_sub_sub`}>
							<Input
								placeholder="Input answer"
								onBlur={(e) =>
									handleChange(e.target.value, `q_${data.id}_sub_sub`, 2)
								}
							/>
						</Form.Item>
					) : null}
				</>
			);
		case "Checkbox":
			let disabled = false;

			if (subAnswer && subAnswer.length === Number(subData.max_checkbox)) {
				disabled = true;
			}
			return (
				<Form.Item
					name={`q_${data.id}_sub`}
					rules={[
						{
							required: data.required ? true : false,
							message: "Please answer the question!",
						},
					]}
				>
					<Checkbox.Group
						size="large"
						onChange={(e) => handleChange(e, `q_${data.id}_sub`, 1)}
						style={{
							width: "100%",
						}}
					>
						<Flex
							vertical="vertical"
							gap={15}
							style={{
								width: "100%",
							}}
						>
							{subData.sub_options
								? subData.sub_options.map((item, index) => {
										return (
											<Checkbox
												key={index}
												value={item.option}
												disabled={
													disabled
														? subAnswer.find((x) => x === item.option)
															? false
															: true
														: false
												}
											>
												{item.option}
											</Checkbox>
										);
								  })
								: ""}
						</Flex>
					</Checkbox.Group>
				</Form.Item>
			);
		case "Select (Dropdown)":
			return (
				<>
					<Form.Item name={`q_${data.id}_sub`}>
						<Select
							placeholder={`Select Answer`}
							size="large"
							options={
								subData && subData.sub_options && subData.sub_options.length > 0
									? subData.sub_options.map((item) => ({
											label: item.option,
											value: item.option,
									  }))
									: []
							}
							onChange={(e) => handleChange(e, `q_${data.id}_sub`, 1)}
						/>
					</Form.Item>

					{isOthers ? (
						<Form.Item name={`q_${data.id}_sub_sub`}>
							<Input
								placeholder="Input answer"
								onBlur={(e) =>
									handleChange(e.target.value, `q_${data.id}_sub_sub`, 2)
								}
							/>
						</Form.Item>
					) : null}
				</>
			);
		case "Date (Datepicker)":
			return (
				<Form.Item
					name={`q_${data.id}_sub`}
					rules={[
						{
							required: subData.required ? true : false,
							message: "Please answer the question!",
						},
					]}
				>
					<DatePicker
						size="large"
						format={{
							format: "MM/DD/YYYY",
							type: "mask",
						}}
						onChange={(date, dateString) => {
							handleChange(dateString, `q_${data.id}_sub`, 1);
						}}
					/>
				</Form.Item>
			);
		default:
			return null;
	}
}
